export default __webpack_public_path__ + "static/media/art-blk-banner-1.ecb93685.jpg";